export { default } from './Header24';
